'use strict';

//////////////////////////////////////////////////////////

class AnswerModel {

    constructor(value, question) {
        this.value = value;
        this.question = question;
    }

    get isChecked() {
        return this.question.hasValue(this.value);
    }

    toggle() {
        this.question.toggle(this.value);
    }


}

class QuestionModel {

    constructor(question, postLeadSurveyService) {
        this.question = question;
        this.title = question.title;
        this.type = question.type;
        this.validAnswers = this.mkAnswers(question);
        this.postLeadSurveyService = postLeadSurveyService;
    }

    isAnswered() {
        return this.question.values.length > 0;
    }

    toggle(value) {
        if (this.hasValue(value)) {
            this.delValue(value);
            this.postLeadSurveyService.saveAnswer(this.question.type, value);
        } else if (this.isSingleAnswer()) {
            this.question.values = [value];
            this.postLeadSurveyService.saveAnswer(this.question.type, value);
        } else if (this.canAddAnotherAnswer()) {
            this.question.values.push(value);
            this.postLeadSurveyService.saveAnswer(this.question.type, value);
        }
    }


    delValue(value) {
        /* istanbul ignore else */
        if (this.question.values.indexOf(value) !== -1) {
            this.question.values = this.question.values.filter((questionValue) => questionValue !== value);
        }
    }

    hasValue(value) {
        return this.question.values.indexOf(value) !== -1;
    }

    mkAnswers(question) {
        const self = this;
        return question.validAnswers.map(answer => {
          return new AnswerModel(answer, self);
        });
    }

    isSingleAnswer() {
        return this.question.allowedCount === 1;
    }

    canAddAnotherAnswer() {
        return this.question.values.length < this.question.allowedCount;
    }

}

class SurveyModel {

    constructor(surveyQuestions, ctrl, postLeadSurveyService, $timeout, pageStateService) {
        this.surveyQuestions = this.mkSurveyQuestions(surveyQuestions, postLeadSurveyService);
        this.currentQuestionIndex = this.findCurrentQuestion();
        this.ctrl = ctrl;
        this.timeout = $timeout;
        this.pageStateService = pageStateService;
    }

    getCurrentQuestion() {
        return this.surveyQuestions[this.currentQuestionIndex];
    }

    getLinkName(currentQuestion, selectedIndex) {
        return "lead-postLead-Q:" + currentQuestion + "-A:" + (selectedIndex + 1);
    }

    goToNext() {
        const self = this;
        self.ctrl.showSkip = false;

        if (self.currentQuestionIndex < self.surveyQuestions.length - 1) {
            self.timeout(function () {
                self.ctrl.showConfirmation = false;
            }, 500);

            self.timeout(function () {
                self.currentQuestionIndex += 1;
                self.ctrl.showConfirmation = true;
                self.ctrl.showTopSkip = true;
            }, 1000);
        } else {
            self.timeout(function () {
                self.ctrl.showTopSkip = false;
                self.ctrl.showConfirmation = false;
            }, 500);

            self.timeout(function () {
                self.ctrl.showConfirmation = true;

                if (self.ctrl.skipThankYouModal) {
                    self.ctrl.closeModal();
                } else {
                    self.ctrl.openModal('typModal');
                }
            }, 1000);
        }
    }

    findCurrentQuestion() {
        return this.surveyQuestions.findIndex(question => {
            return !question.isAnswered();
        });
    }

    mkSurveyQuestions(surveyQuestions, postLeadSurveyService) {
        return surveyQuestions.map(question => {
          return new QuestionModel(question, postLeadSurveyService);
        });
    }
}

function controller(postLeadSurveyService, modalService, $timeout, pageStateService) {
    const ctrl = this;

    ctrl.$onInit = function () {
        postLeadSurveyService.loadCtrl(ctrl);
        postLeadSurveyService.setProxyInfo(ctrl.apigeeHost, ctrl.shadowSettingsProxy, ctrl.vdpApiKey);
        ctrl.showTopSkip = false;
        ctrl.showSkip = true;
        ctrl.skipThankYouModal = false;
        ctrl.pageStateService = pageStateService;
    };

    ctrl.onOpen = function (questions) {
        ctrl.surveyQuestionsList = questions;
        ctrl.model = new SurveyModel(ctrl.surveyQuestionsList, ctrl, postLeadSurveyService, $timeout, pageStateService);
    };

    ctrl.openModal = function (modal) {
        modalService.get(modal).toggle();
    };

    ctrl.closeModal = function () {
        modalService.closeAll();
    };

    ctrl.setVdpVariables = function (skipThankYouModal) {
        ctrl.skipThankYouModal = skipThankYouModal;
    };
}

controller.$inject = [
    'postLeadSurveyService',
    'modalService',
    '$timeout',
    'pageStateService'
];

export default controller;
